import React from 'react';
import { toQueryParams } from '../../../../../../../../helpers/ajaxRequest';
import { API, AttraqtSuggestionsSearchTerm } from '../../../../../../../../types';
import suggestionStyles from './suggestion.module.pcss';

interface SuggestionProps {
  suggestion: AttraqtSuggestionsSearchTerm;
}

function Suggestion({ suggestion }: SuggestionProps): React.ReactElement {
  const { term, nrResults } = suggestion;
  const url = `${API.SEARCH}?${toQueryParams({ text: term })}`;

  return (
    <a tabIndex={0} href={url} className={suggestionStyles.suggestion}>
      <span className={suggestionStyles.suggestion__category}>{term}</span>
      <span className={suggestionStyles.suggestion__count}>{nrResults}</span>
    </a>
  );
}

export default Suggestion;
